<div [innerHTML]="sanitizedContent" class="email-content"></div>